package org.example.zone360.pages.players_Details.assistAI

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.utils.createSubscriptionCheckout
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CustomDivider
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetSinglePlayerData
import org.example.zone360.theme.Palette
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.SubscriptionPlan
import org.example.zone360.utils.toMoney
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px


@Composable
fun SubscriptionsPayment(
    sitePalette: SitePalette,
    breakpoint: Breakpoint,
    onDialogDismiss: () -> Unit,
    getPlayerInfo: GetSinglePlayerData,
    toastMessage: (String) -> Unit
) {
    val scope = rememberCoroutineScope()
    var isLoading by remember { mutableStateOf(false) }

    // default selection => Annual (best for conversion)
    var selectedPlan by remember { mutableStateOf(SubscriptionPlan.ANNUAL) }

    //  Pricing
    val monthlyPrice = 9.95
    val annualPrice = 110.0
    val yearlyFromMonthly = monthlyPrice * 12
    val savings = yearlyFromMonthly - annualPrice
    val savingsPercent = (savings / yearlyFromMonthly) * 100

    fun getSelectedPlan(): String {
        return when (selectedPlan) {
            SubscriptionPlan.MONTHLY -> "monthly"
            SubscriptionPlan.ANNUAL -> "yearly"
        }
    }


    Box(
        modifier = Modifier
            .fillMaxSize()
            .position(Position.Fixed)
            .zIndex(9999999)
            .backgroundColor(Palette.Grey.rgbLight.copyf(alpha = 0.7f)),
        contentAlignment = Alignment.Center
    ) {
        Box(
            modifier = Modifier
                .width(if (breakpoint < Breakpoint.MD) 400.px else 520.px),
            contentAlignment = Alignment.Center
        ) {

            // click catcher behind modal
            Box(
                modifier = Modifier
                    .width(90.percent)
                    .height(100.percent)
                    .onClick { }
            )

            Box(
                modifier = Modifier
                    .width(90.percent)
                    .margin(top = 10.px)
                    .height(100.percent)
                    .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                    .border(
                        width = 1.px,
                        color = sitePalette.textFieldBorderColor.rgb,
                        style = LineStyle.Solid
                    )
                    .borderRadius(4.px),
                contentAlignment = Alignment.Center
            ) {
                Column(modifier = Modifier.fillMaxSize()) {

                    // HEADER
                    Row(
                        horizontalArrangement = Arrangement.SpaceBetween,
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(15.px)
                            .margin(bottom = 15.px),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        FieldTitleTextNormalSimple(
                            "Choose Your Subscription",
                            fontSize = 20.px,
                            fontWeight = 600,
                            onClick = {}
                        )

                        FaXmark(
                            modifier = Modifier
                                .color(sitePalette.commonButtonSupportiveTextColor.rgb)
                                .cursor(Cursor.Pointer)
                                .onClick { onDialogDismiss() },
                            size = IconSize.LG
                        )
                    }

                    //  PLAN PICKER
                    if (breakpoint < Breakpoint.MD) {
                        // Mobile => Column
                        Column(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(leftRight = 15.px),
                            verticalArrangement = Arrangement.spacedBy(12.px)
                        ) {
                            PlanCard(
                                title = "Monthly",
                                priceText = "$9.95",
                                periodText = "/month",
                                subtitle = "Billed monthly",
                                extraLine = "Cancel anytime",
                                isSelected = selectedPlan == SubscriptionPlan.MONTHLY,
                                isBestValue = false,
                                sitePalette = sitePalette,
                                onClick = { selectedPlan = SubscriptionPlan.MONTHLY }
                            )

                            PlanCard(
                                title = "Annual",
                                priceText = "$110",
                                periodText = "/year",
                                subtitle = "Only $${(annualPrice / 12).toMoney(2)}/mo billed yearly",
                                extraLine = "Cancel anytime",
                                isSelected = selectedPlan == SubscriptionPlan.ANNUAL,
                                isBestValue = false,
                                sitePalette = sitePalette,
                                onClick = { selectedPlan = SubscriptionPlan.ANNUAL }
                            )

                        }
                    } else {
                        // Desktop => Row
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(leftRight = 15.px),
                            horizontalArrangement = Arrangement.spacedBy(12.px)
                        ) {
                            PlanCard(
                                title = "Monthly",
                                priceText = "$9.95",
                                periodText = "/month",
                                subtitle = "Billed monthly",
                                extraLine = "Cancel anytime",
                                isSelected = selectedPlan == SubscriptionPlan.MONTHLY,
                                isBestValue = false,
                                sitePalette = sitePalette,
                                onClick = { selectedPlan = SubscriptionPlan.MONTHLY }
                            )

                            PlanCard(
                                title = "Annual",
                                priceText = "$110",
                                periodText = "/year",
                                subtitle = "Only $${(annualPrice / 12).toMoney(2)}/mo billed yearly",
                                extraLine = "Cancel anytime",
                                isSelected = selectedPlan == SubscriptionPlan.ANNUAL,
                                isBestValue = false,
                                sitePalette = sitePalette,
                                onClick = { selectedPlan = SubscriptionPlan.ANNUAL }
                            )

                        }
                    }

                    // Processing fee + small info
                    FieldTitleTextNormalSimple(
                        "+$6 Processing fee",
                        width = 100.percent,
                        marginBottom = 25.px,
                        marginTop = 12.px,
                        textAlign = TextAlign.Center
                    )

                    Row(
                        Modifier.fillMaxWidth().padding(leftRight = 15.px),
                        horizontalArrangement = Arrangement.Center
                    ) {
                        CommonButton(
                            text = when (selectedPlan) {
                                SubscriptionPlan.MONTHLY -> "Continue with Monthly"
                                SubscriptionPlan.ANNUAL -> "Continue with Annual"
                            },
                            onCLick = {
                                scope.launch {
                                    isLoading = true
                                    try {
                                        val response = createSubscriptionCheckout(
                                            plan = getSelectedPlan(),
                                            organization = getPlayerInfo.organization,
                                            userID = getPlayerInfo.uid,
                                            email = AppGlobal.userData.email,
                                            stripCustomerID = if (AppGlobal.userData.stripCustomerID == null) ""
                                            else AppGlobal.userData.stripCustomerID!!
                                        )

                                            if (response.checkout_url != null) {
                                                isLoading = false
                                                val url = response.checkout_url
                                                if (url.isNotBlank()) {
                                                    kotlinx.browser.window.open(url, "_self")
                                                }
                                            } else {
                                                isLoading = false
                                                toastMessage(response.error!!)
                                                showToast("toastError")
                                            }
                                    } catch (e: Throwable) {
                                        isLoading = false
                                        toastMessage(e.message.toString())
                                        showToast("toastError")
                                    }
                                }
                            },
                            width = 80.percent,
                            isLoading = isLoading
                        )
                    }

                    //  Features section (same for both plans)
                    CustomDivider(modifier = Modifier.margin(topBottom = 25.px))

                    FieldTitleTextNormalSimple(
                        "Includes:",
                        width = 100.percent,
                        marginBottom = 20.px,
                        textAlign = TextAlign.Center,
                        fontWeight = 600
                    )

                    FieldTitleTextNormalSimple(
                        "Unlimited memory",
                        width = 100.percent,
                        marginBottom = 18.px,
                        textAlign = TextAlign.Center
                    )
                    FieldTitleTextNormalSimple(
                        "Player's profile",
                        width = 100.percent,
                        marginBottom = 18.px,
                        textAlign = TextAlign.Center
                    )
                    FieldTitleTextNormalSimple(
                        "Unlimited assessments",
                        width = 100.percent,
                        marginBottom = 18.px,
                        textAlign = TextAlign.Center
                    )
                    FieldTitleTextNormalSimple(
                        "Unlimited questions to bot",
                        width = 100.percent,
                        marginBottom = 18.px,
                        textAlign = TextAlign.Center
                    )
                    FieldTitleTextNormalSimple(
                        "Shareable profile",
                        width = 100.percent,
                        marginBottom = 30.px,
                        textAlign = TextAlign.Center
                    )
                }
            }
        }
    }
}

/**
 * ✅ Reusable Plan Card Composable
 */
@Composable
fun PlanCard(
    modifier: Modifier = Modifier,
    title: String,
    priceText: String,
    periodText: String,
    subtitle: String,
    isSelected: Boolean,
    isBestValue: Boolean,
    extraLine: String? = null,
    sitePalette: SitePalette,
    onClick: () -> Unit
) {
    val borderColor = if (isSelected) sitePalette.primary.rgb else sitePalette.textFieldBorderColor.rgb
    val backgroundColor = if (isSelected) sitePalette.primary.rgb.copyf(alpha = 0.08f) else sitePalette.modalBackgroundColor.rgb

    Box(
        modifier = modifier
            .fillMaxWidth()
            .cursor(Cursor.Pointer)
            .backgroundColor(backgroundColor)
            .border(width = 2.px, color = borderColor, style = LineStyle.Solid)
            .borderRadius(10.px)
            .padding(14.px)
            .onClick { onClick() }
    ) {
        Column {

            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                FieldTitleTextNormalSimple(
                    title,
                    fontSize = 16.px,
                    fontWeight = 600,
                    onClick = {}
                )

                if (isBestValue) {
                    Box(
                        modifier = Modifier
                            .backgroundColor(sitePalette.primary.rgb.copyf(alpha = 0.15f))
                            .borderRadius(50.px)
                            .padding(leftRight = 10.px, topBottom = 5.px)
                    ) {
                        FieldTitleTextNormalSimple(
                            "Best Value",
                            fontSize = 12.px,
                            fontWeight = 600,
                            onClick = {}
                        )
                    }
                }
            }

            Row(
                modifier = Modifier.margin(top = 10.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                FieldTitleTextNormalSimple(
                    priceText,
                    fontSize = 30.px,
                    fontWeight = 700,
                    onClick = {}
                )
                FieldTitleTextNormalSimple(
                    periodText,
                    fontSize = 14.px,
                    marginLeft = 6.px,
                    onClick = {}
                )
            }

            FieldTitleTextNormalSimple(
                subtitle,
                fontSize = 13.px,
                width = 100.percent,
                marginTop = 6.px,
                onClick = {}
            )

            if (extraLine != null) {
                FieldTitleTextNormalSimple(
                    extraLine,
                    fontSize = 13.px,
                    width = 100.percent,
                    marginTop = 6.px,
                    fontWeight = 600,
                    onClick = {}
                )
            }
        }
    }
}

